export default "__VITE_ASSET__SqLqqRzp__"